import { getModalByTemplate } from "../../../../modal";

export function newsletter() {
    const formNewsletter = document.getElementById("form-newsletter");
    const buttonSubmit = formNewsletter.querySelector("[type=submit]")

    formNewsletter.addEventListener("submit", function (e) {
        e.preventDefault()
        buttonSubmit.classList.add("disabled", "loading")
        var CRAFT_CSRF_NAME = window.csrfTokenName;
        var CRAFT_CSRF_TOKEN = window.csrfTokenValue;

        let formData = new FormData()
        formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN);
        formData.append('newsletter-email', document.querySelector('#newsletter-email').value);
        formData.append('newsletter-nome', document.querySelector('#newsletter-nome').value);
        formData.append('newsletter-telefone', document.querySelector('#newsletter-telefone').value);

        fetch('/actions/general-module/newsletter/cadastro-newsletter', {
            method: "POST",
            body: formData,
        }).then((response) => {
            return response.json();
        }).then((json) => {
            if (json.success) {
                document.querySelectorAll("#form-newsletter fieldset").forEach(function (el) {
                    el.classList.add("disabled")
                })

                buttonSubmit.classList.remove("loading")
                buttonSubmit.innerHTML = "Enviado com sucesso!"

                getModalByTemplate("newsletter-sent");
            } else {
                buttonSubmit.classList.remove("disabled", "loading")

                getModalByTemplate("generic-error", {
                    title: "Não foi possível realizar o seu cadastro",
                    description: json.message,
                });
            }
        })
    })
}

if (document.getElementById("form-newsletter")) {
    newsletter()
}
